<template>
  <div class="container-fluid">
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="heading-color text-center p-5">Cant Find What <br> You're Looking For?</h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-5">
            <form @submit.prevent="submit">
              <div class="form-group">
                <input type="email" v-model="email" class="form-control" required id="email" placeholder="Email Address">
              </div>
              <div class="form-group">
                <textarea class="form-control" v-model="message" rows="6" required id="message" placeholder="Your Message"></textarea>
              </div>
              <p class="error">
                {{this.captcha.pleaseTickRecaptchaMessage}}
              </p>
              <div class="row">
                <div class="col-md-8">
                  <vue-recaptcha @expired="markRecaptchaAsExpired" @verify="markRecaptchaAsVerified" class="d-md-block d-flex justify-content-center" sitekey="6LdnyhAaAAAAAJV900AgZbaRwLtbEivUAgoNMO3m" :loadRecaptchaScript="true"></vue-recaptcha>
                </div>
                <div class="col-md-4 mt-md-0 mt-3">
                  <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-submit w-100">
                    <div v-if="this.$store.getters.apiStatus != 'loading'">Send Message</div>
                    <div v-else class="loader"><Loader></Loader></div>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default{
  name: 'Help',
  components: { VueRecaptcha },
  data () {
    return {
      email: '',
      message: '',
      captcha: {
        recaptchaVerified: false,
        pleaseTickRecaptchaMessage: '',
        value: null
      }
    }
  },
  methods: {
    markRecaptchaAsExpired (response) {
      this.captcha.pleaseTickRecaptchaMessage = 'Error: Captcha has expired'
      this.captcha.recaptchaVerified = false
      this.captcha.value = null
    },
    markRecaptchaAsVerified (response) {
      this.captcha.pleaseTickRecaptchaMessage = ''
      this.captcha.recaptchaVerified = true
      this.captcha.value = response
    },
    submit () {
      if (!this.isCaptchaVerified()) return
      this.$store.dispatch('postHelp', { email: this.email, message: this.message, captcha: this.captcha.value })
        .then((resp) => {
          this.$router.push('/')
          this.$toast.success(resp.data.message)
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message)
        })
    },
    isCaptchaVerified () {
      if (!this.captcha.recaptchaVerified) {
        this.captcha.pleaseTickRecaptchaMessage = 'Error: Please verify captcha'
        return false // prevent form from submitting
      }
      return true
    }
  }
}
</script>

<style scoped>
.btn-submit {
  background: #c5263c;
  border-color: #c5263c;
  font-size: 80%;
  padding: 8px 20px;
  color: white;
  min-height: 37px;
}
input, textarea {
  border-color: #bababa;
}
textarea:active,
textarea:focus,
input:active,
input:focus {
  box-shadow: none;
  border-color: black
}
.heading-color {
  padding-bottom: 12px !important;
}
.error {
  color: #c5263c
}
</style>



// WEBPACK FOOTER //
// src/views/Help.vue